import * as React from 'react';
import PropTypes from 'prop-types';
import { Pivot, PivotItem, List } from '@fluentui/react';
import { SearchTableItem } from './SearchTableItem';
import '../SearchTable.scss';

// Table: takes table info in the form of {header: [items...]} rendering a table item
// per item.

const SearchTable = ({ tableInfo = {}, isSearching }) => {
  const onRenderCell = React.useCallback((item) => {
    return (<SearchTableItem item={item} />);
  }, []);

  const tableHeaders = Object.keys(tableInfo);
  return (
    <div id={'search-results-table'} className={isSearching ? 'searchTable-deactivate' : ''}>
      <Pivot className="searchTable-tabs">
        {/* If values are present for the object, display them in a list using the onRenderCell function, otherwise
        fallback to the default "nothing found" in SearchTableItem */}
        {tableHeaders.map((header) =>
          <PivotItem headerText={header} key={header} itemKey={header} id={`id ${header}`}>
            {tableInfo[header]?.length ? <List items={tableInfo[header]} onRenderCell={onRenderCell} /> :
            <SearchTableItem />
            }
          </PivotItem>,
        )}
      </Pivot>
    </div>
  );
};

SearchTable.propTypes = {
  tableInfo: PropTypes.object,
  isSearching: PropTypes.bool,
};

export default SearchTable;
